import { useEffect, useRef, EffectCallback, DependencyList } from 'react';

export function useEffectExceptFirst(effect: EffectCallback, deps: DependencyList) {
  const firstRun = useRef(true);

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    return effect();
  }, deps);
}
